/**Import react section */
import React, { useEffect, useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

/**Import components section */
import Toaster from '../common/Toaster'
import SparePartImagesDesktopView from './SparePartImagesDesktopView'
import {
	deleteSparePartImage,
	downloadSparePartImagesReport,
	getAllSparePartImage,
	getSparePartImage,
	saveSparePartImage
} from '../../store/SparePartImages/SparePartImagesActions'

/**Import Helpers section */
import { isNullOrEmpty } from '../../store/helpers/StringHelper'

const SparePartImagesIndex = (props) => {
	const history = useHistory()
	const dispatch = useDispatch()

	let match = useRouteMatch()
	const serieFromPath = match.params.serie

	const userProfile = useSelector((state) => state.session.get('profile'))
	const sparePartImage = useSelector((state) => state.sparePartImages.get('sparePartImage'))
	const imagesByCodeSearch = useSelector((state) => state.sparePartImages.get('imagesByCodeSearch'))
	const isDeletingImage = useSelector((state) => state.sparePartImages.get('isDeletingSparePartImage'))
	const isUploadingImage = useSelector((state) => state.sparePartImages.get('isUploadingImage'))
	const isGetingImageContainer = useSelector((state) => state.sparePartImages.get('isGetingImageContainer'))

	const [toaster, setToaster] = useState({
		open: false,
		variant: null,
		message: null
	})

	const [confirmDialog, setConfirmDialog] = useState({
		open: false,
		imageName: ''
	})

	const onChangeLocation = (location) => history.push(location)

	useEffect(() => {
		if (serieFromPath) {
			dispatch(getSparePartImage(serieFromPath)).catch((error) => {
				setToaster({
					open: true,
					message: !isNullOrEmpty(error.Message) ? error.Message : 'An error to get Spare part images',
					variant: 'warning'
				})
			})
		}
	}, [dispatch, serieFromPath])

	const addImage = (files) => {
		return dispatch(saveSparePartImage(files))
			.then(() => {
				setToaster({ open: true, message: 'Images uploaded correctly', variant: 'success' })
			})
			.catch((error) => {
				setToaster({ open: true, message: !isNullOrEmpty(error.Message) ? error.Message : 'An error uploading image', variant: 'warning' })
			})
	}
	const deleteImage = (code, imageName) => {
		return dispatch(deleteSparePartImage(code, imageName))
			.then(handleCloseConfirmDialog())
			.catch((error) => {
				setToaster({ open: true, message: !isNullOrEmpty(error.Message) ? error.Message : 'An error deleting image', variant: 'warning' })
			})
	}
	const handleOpenConfirmDialog = (imageName) => {
		setConfirmDialog({
			open: true,
			imageName: imageName
		})
	}
	const handleCloseConfirmDialog = () => {
		setConfirmDialog({
			open: false,
			imageName: ''
		})
	}
	const onSearchSerie = (code) => {
		dispatch(getAllSparePartImage(code)).catch((error) => {
			setToaster({
				open: true,
				message: !isNullOrEmpty(error.Message) ? error.Message : 'An error to get Spare part images',
				variant: 'warning'
			})
		})
	}

	const onDownloadSparePartImagesReport = () => {
		return dispatch(downloadSparePartImagesReport())
			.then((_) => {})
			.catch((error) => {
				setToaster({
					open: true,
					message: !isNullOrEmpty(error.Message) ? error.Message : 'An error downloadspare part images report',
					variant: 'warning'
				})
			})
	}

	return (
		<>
			<SparePartImagesDesktopView
				userProfile={userProfile}
				sparePartImage={sparePartImage}
				confirmDialog={confirmDialog}
				imagesByCodeSearch={imagesByCodeSearch}
				onChangeLocation={onChangeLocation}
				addImage={addImage}
				deleteImage={deleteImage}
				handleOpenConfirmDialog={handleOpenConfirmDialog}
				handleCloseConfirmDialog={handleCloseConfirmDialog}
				onSearchSerie={onSearchSerie}
				isUploadingImage={isUploadingImage}
				isDeletingImage={isDeletingImage}
				isGetingImageContainer={isGetingImageContainer}
				serieFromPath={serieFromPath}
				onDownloadSparePartImagesReport={onDownloadSparePartImagesReport}
			/>
			<Toaster toasterOptions={toaster} onClose={() => setToaster({ open: false })} />
		</>
	)
}

export default SparePartImagesIndex
